/**
 * Success page shown after successful Stripe Checkout
 */

import React, { useEffect } from 'react';
import { Container, Paper, Typography, Button, Box } from '@mui/material';
import { CheckCircle2 as CheckCircleIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const SuccessPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Optional: Refresh subscription status on the billing page
    // This ensures the billing page shows the updated subscription
  }, []);

  return (
    <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
      <Paper elevation={3} sx={{ p: 6 }}>
        <CheckCircleIcon size={80} color="var(--ab-approved)" />

        <Typography variant="h4" gutterBottom>
          Subscription Successful!
        </Typography>

        <Typography variant="body1" color="text.secondary" paragraph>
          Thank you for subscribing to AppealBot. Your subscription is now active
          and you have access to all premium features.
        </Typography>

        <Box sx={{ mt: 4, display: 'flex', gap: 2, justifyContent: 'center' }}>
          {/* Stripe Checkout returns here (STRIPE_SUCCESS_URL). Onboarding wants
              users to land in the real app dashboard, so the primary CTA goes
              to /overview; billing management stays available as a secondary. */}
          <Button
            variant="contained"
            onClick={() => navigate('/overview')}
          >
            Go to Dashboard
          </Button>
          <Button
            variant="outlined"
            onClick={() => navigate('/billing')}
          >
            View Billing
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default SuccessPage;
